define('plugin/location/view/LocationEmptyView',['require','lib/view/LayoutView'],function (require) {

	var LayoutView = require('lib/view/LayoutView');
	
	/**
	 * Location empty view
	 * 
	 * @class LocationEmptyView
	 */
	return LayoutView.extend({

		template: '#location_empty'
	    
	});
	
});
